import axios from "axios";

import { API_BASE_URL } from '../../config/apiConfig';

// ==============================================

// 1. Get Stock Purchase Consolidate Tax Numbers
export const getStockPurchaseConsolidateTaxNos = async () => {
    try {
         // DEBUG
        
        const response = await axios.get(
            `${API_BASE_URL}/Reports/GetStockPurchaseConsolidateTaxNos`,
            {
                headers: {
                    'Content-Type': 'application/json'
                }
            }
        );
        
         // DEBUG
        return response.data;
    } catch (error) {
        if (error.response?.data) {
            throw error.response.data;
        }
        throw error;
    }
};

// 2. Get Stock Purchase Consolidate Report Grid
export const getStockPurchaseConsolidateReportGrid = async (params) => {
    try {
        const { taxno, fromDate, toDate } = params;
         // DEBUG
        
        const queryParams = new URLSearchParams({
            Taxno: taxno || '',
            FromDate: fromDate || '',
            ToDate: toDate || ''
        });
        
        const response = await axios.get(
            `${API_BASE_URL}/Reports/GetStockPurchaseConsolidateReportGrid?${queryParams}`,
            {
                headers: {
                    'Content-Type': 'application/json'
                }
            }
        );
        
         // DEBUG
        return response.data;
    } catch (error) {
        if (error.response?.data) {
            throw error.response.data;
        }
        throw error;
    }
};

// 3. Get Stock Purchase Report Grid
export const getStockPurchaseReportGrid = async (params) => {
    try {
        const { taxno, fromDate, toDate } = params;
         // DEBUG
        
        const queryParams = new URLSearchParams({
            Taxno: taxno || '',
            FromDate: fromDate || '',
            ToDate: toDate || ''
        });
        
        const response = await axios.get(
            `${API_BASE_URL}/Reports/GetStockPurchaseReportGrid?${queryParams}`,
            {
                headers: {
                    'Content-Type': 'application/json'
                }
            }
        );
        
         // DEBUG
        return response.data;
    } catch (error) {
        if (error.response?.data) {
            throw error.response.data;
        }
        throw error;
    }
};